(function () {
  var RIGHT_PX = 20;
  var GAP_PX = 12;
  var MANAGED_ATTR = 'data-ss-klaviyo-teaser-position';
  var teaserSelector = "[class*='kl-teaser-']";
  var chatSelectors = ['.rp-micro-app-dummy-icon', '.rp-micro-app-dummy-icon-container', '.rp-micro-app-messenger'];
  var targetSelector = teaserSelector + ', ' + chatSelectors.join(', ');
  var teasers = [];
  var chats = [];
  var structureObserver = null;
  var attributeObserver = null;
  var resizeObserver = null;
  var discoveryObserver = null;
  var discoveryTimer = null;
  var frame = null;
  var correctionPass = 0;
  var motionTargets = [];

  function connected(node) { return !!(node && node.isConnected); }
  function roundPx(value) { return Math.round(value * 100) / 100; }
  function setImportant(node, property, value) {
    if (node.style.getPropertyValue(property) === value && node.style.getPropertyPriority(property) === 'important') return false;
    node.style.setProperty(property, value, 'important');
    return true;
  }
  function isVisible(rect) {
    return rect && rect.width >= 24 && rect.height >= 24 && rect.bottom > 0 && rect.right > 0 &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight || 0);
  }
  function forgetDisconnected() {
    // Keep a connected, temporarily declassified/hidden widget in the cache so
    // its local attribute observer can detect its reappearance.
    teasers = teasers.filter(function (record) { return connected(record.node); });
    chats = chats.filter(connected);
  }
  function remember(node) {
    if (!node || node.nodeType !== 1 || !connected(node)) return false;
    if (node.matches(teaserSelector)) {
      if (teasers.some(function (record) { return record.node === node; })) return false;
      teasers.push({ node: node, normalized: false, writtenStyle: null });
      return true;
    }
    if (chatSelectors.some(function (selector) { return node.matches(selector); }) && chats.indexOf(node) === -1) {
      chats.push(node);
      return true;
    }
    return false;
  }
  function scan(node) {
    var changed = remember(node);
    if (node && node.querySelectorAll) {
      Array.prototype.forEach.call(node.querySelectorAll(targetSelector), function (target) { changed = remember(target) || changed; });
    }
    return changed;
  }

  function stopDiscovery() {
    if (discoveryObserver) discoveryObserver.disconnect();
    if (discoveryTimer !== null) window.clearTimeout(discoveryTimer);
    discoveryObserver = null;
    discoveryTimer = null;
  }
  function schedule() {
    correctionPass = 0;
    teasers.forEach(function (record) { record.previousMeasurement = null; });
    queueFrame();
  }
  function queueFrame() {
    if (frame !== null || !teasers.length) return;
    frame = window.requestAnimationFrame(function () { frame = null; apply(); });
  }
  function ownStyleMutation(change) {
    if (change.attributeName !== 'style') return false;
    return teasers.some(function (record) {
      return record.node === change.target && record.writtenStyle !== null &&
        record.writtenStyle === record.node.getAttribute('style');
    });
  }
  function motionFinished(event) {
    if (motionTargets.indexOf(event.target) !== -1) schedule();
  }
  function clearMotionWatchers() {
    motionTargets.forEach(function (node) {
      node.removeEventListener('transitionend', motionFinished, true);
      node.removeEventListener('animationend', motionFinished, true);
    });
    motionTargets = [];
  }
  function updateWatchers() {
    clearMotionWatchers();
    if (structureObserver) structureObserver.disconnect();
    if (attributeObserver) attributeObserver.disconnect();
    if (resizeObserver) resizeObserver.disconnect();
    structureObserver = new MutationObserver(function (changes) {
      var changed = false;
      changes.forEach(function (change) {
        Array.prototype.forEach.call(change.addedNodes, function (node) { changed = scan(node) || changed; });
        changed = changed || Array.prototype.some.call(change.removedNodes, function (removed) {
          return teasers.map(function (record) { return record.node; }).concat(chats).some(function (node) {
            return removed === node || (removed.contains && removed.contains(node));
          });
        });
      });
      if (!changed) return;
      forgetDisconnected();
      updateWatchers();
      if (teasers.length && chats.length) stopDiscovery();
      else startDiscovery(false);
      schedule();
    });
    attributeObserver = new MutationObserver(function (changes) {
      if (!changes.some(function (change) { return !ownStyleMutation(change); })) return;
      forgetDisconnected();
      schedule();
    });
    resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    var ancestors = [];
    teasers.map(function (record) { return record.node; }).concat(chats).forEach(function (target) {
      var node = target;
      while (node && node !== document.documentElement) {
        if (ancestors.indexOf(node) === -1) {
          ancestors.push(node);
          // Direct child changes catch widget/container replacement, including
          // a portal attached directly to body, without observing all descendants.
          structureObserver.observe(node, { childList: true });
          if (node !== document.body) {
            attributeObserver.observe(node, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
            if (resizeObserver) resizeObserver.observe(node);
            // A class/style mutation can precede the final animated position.
            // Listen only on the cached widgets and their scoped ancestors.
            motionTargets.push(node);
            node.addEventListener('transitionend', motionFinished, true);
            node.addEventListener('animationend', motionFinished, true);
          }
        }
        node = node.parentElement;
      }
    });
  }

  function startDiscovery(initialScan) {
    if (initialScan) {
      forgetDisconnected();
      scan(document.body);
      updateWatchers();
      schedule();
    }
    if (teasers.length && chats.length) { stopDiscovery(); return; }
    if (discoveryObserver) return;
    // Only startup/recovery discovery is broad, and it is time bounded. Once
    // both widgets exist their own ancestors handle hidden/reappearing states.
    discoveryObserver = new MutationObserver(function (changes) {
      var changed = false;
      changes.forEach(function (change) {
        if (change.type === 'attributes') changed = remember(change.target) || changed;
        else Array.prototype.forEach.call(change.addedNodes, function (node) { changed = scan(node) || changed; });
      });
      if (!changed) return;
      updateWatchers();
      if (teasers.length && chats.length) stopDiscovery();
      schedule();
    });
    discoveryObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    discoveryTimer = window.setTimeout(stopDiscovery, 90000);
  }

  function apply() {
    forgetDisconnected();
    if (!teasers.length) return;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var chatRects = chats.map(function (node) {
      return { node: node, rect: node.getBoundingClientRect() };
    });
    var chatRect = null;
    chatSelectors.some(function (selector) {
      return chatRects.some(function (item) {
        if (item.node.matches(selector) && !item.node.classList.contains('rp-micro-app-hide') && isVisible(item.rect)) {
          chatRect = item.rect;
          return true;
        }
        return false;
      });
    });
    var desiredBottom = chatRect ? Math.max(20, Math.round(viewportHeight - chatRect.top + GAP_PX)) : 92;
    // One read phase for every teaser. Never read a rect after writing styles
    // in this frame; transformed visual offsets are corrected next frame.
    var measured = teasers.map(function (record) {
      var node = record.node;
      var rect = node.getBoundingClientRect();
      return { record: record, rect: rect, position: window.getComputedStyle(node).position,
        right: parseFloat(node.style.getPropertyValue('right')) || 0,
        bottom: parseFloat(node.style.getPropertyValue('bottom')) || 0 };
    });
    var needsCorrection = false;
    measured.forEach(function (item) {
      var record = item.record;
      var node = record.node;
      var rect = item.rect;
      if (!node.matches(teaserSelector) || !isVisible(rect) || item.position !== 'fixed' || rect.width > Math.min(340, viewportWidth * 0.85) ||
        rect.height > Math.min(270, viewportHeight * 0.5)) return;
      var normalize = !record.normalized || node.style.getPropertyValue('left') !== 'auto' ||
        node.style.getPropertyValue('top') !== 'auto' || node.style.getPropertyPriority('left') !== 'important' ||
        node.style.getPropertyPriority('top') !== 'important';
      if (normalize) {
        setImportant(node, 'left', 'auto');
        setImportant(node, 'top', 'auto');
        setImportant(node, 'right', RIGHT_PX + 'px');
        setImportant(node, 'bottom', desiredBottom + 'px');
        if (node.getAttribute(MANAGED_ATTR) !== 'true') node.setAttribute(MANAGED_ATTR, 'true');
        record.normalized = true;
        record.previousMeasurement = null;
        needsCorrection = true;
      } else {
        var rightDelta = RIGHT_PX - (viewportWidth - rect.right);
        var bottomDelta = desiredBottom - (viewportHeight - rect.bottom);
        // Fixed widgets can also sit inside a scaled ancestor. Infer the local
        // CSS-to-visual ratio from our preceding correction, instead of needing
        // an unbounded sequence of one-pixel-assumption corrections.
        var previous = record.previousMeasurement;
        function ratio(cssValue, visualValue, oldCss, oldVisual) {
          if (!previous || Math.abs(cssValue - oldCss) < 0.1) return 1;
          var scale = (visualValue - oldVisual) / (cssValue - oldCss);
          return isFinite(scale) && scale > 0.05 && scale < 20 ? scale : 1;
        }
        var rightScale = ratio(item.right, viewportWidth - rect.right, previous && previous.right, previous && previous.visualRight);
        var bottomScale = ratio(item.bottom, viewportHeight - rect.bottom, previous && previous.bottom, previous && previous.visualBottom);
        record.previousMeasurement = { right: item.right, bottom: item.bottom,
          visualRight: viewportWidth - rect.right, visualBottom: viewportHeight - rect.bottom };
        if (Math.abs(rightDelta) > 0.1) needsCorrection = setImportant(node, 'right', roundPx(item.right + rightDelta / rightScale) + 'px') || needsCorrection;
        if (Math.abs(bottomDelta) > 0.1) needsCorrection = setImportant(node, 'bottom', roundPx(item.bottom + bottomDelta / bottomScale) + 'px') || needsCorrection;
      }
      record.writtenStyle = node.getAttribute('style');
    });
    // At most a few visual corrections per outside event. Own style mutation
    // records are ignored, so a transformed widget cannot create an idle loop.
    if (needsCorrection && correctionPass < 3) { correctionPass += 1; queueFrame(); }
  }

  function stop() {
    stopDiscovery();
    clearMotionWatchers();
    if (structureObserver) structureObserver.disconnect();
    if (attributeObserver) attributeObserver.disconnect();
    if (resizeObserver) resizeObserver.disconnect();
    if (frame !== null) window.cancelAnimationFrame(frame);
    frame = null;
  }
  function boot() {
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    window.addEventListener('pagehide', stop);
    window.addEventListener('pageshow', function () { startDiscovery(true); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) startDiscovery(true); });
    // A widget intentionally loaded after interaction gets a fresh bounded
    // discovery window even if its initial 90-second startup window expired.
    document.addEventListener('pointerdown', function () {
      if (!teasers.length || !chats.length) startDiscovery(!discoveryObserver);
    }, { passive: true });
    startDiscovery(true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
